<template>
    <div>
        <card>
            <h3>Corsisti</h3>
            <form>
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="nome_corsista">Nome</label>
                        <input type="text" class="form-control" id="nome_corsista" v-model="nome_corsista" placeholder="nome corsista">
                    </div>
                    <div class="form-group col-md-4">
                        <label for="cognome_corsista">Cognome</label>
                        <input type="text" class="form-control" id="cognome_corsista" v-model="cognome_corsista">
                    </div>
                    <div class="form-group col-md-4">
                        <label for="nome_azienda">Nome azienda</label> 
                        <input type="text" class="form-control" id="nome_azienda" v-model="nome_azienda" placeholder="nome azienda">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="cellulare_corsista">Telefono Cellulare</label>
                        <input type="text" class="form-control" id="cellulare_corsista" v-model="cellulare_corsista">
                    </div>
                    <div class="form-group col-md-4">
                        <label for="ufficio_corsista">Telefono Ufficio</label>
                        <input type="text" class="form-control" id="ufficio_corsista" v-model="ufficio_corsista">
                    </div>
                    <div class="form-group col-md-4">
                        <label for="fax_corsista">Fax</label>
                        <input type="text" class="form-control" id="fax_corsista" v-model="fax_corsista">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="email_corsista">Indirizzo Email</label>
                        <input type="text" class="form-control" id="email_corsista" v-model="email_corsista">
                    </div>
                    <div class="form-group col-md-6">
                        <label for="mansione_corsista">Mansione</label>
                        <input type="text" class="form-control" id="mansione_corsista" v-model="mansione_corsista" placeholder="mansione corsista">
                    </div>
                    <!-- <div class="form-group col-md-4">
                        <label for="non_chiamare">Non chiamare</label>
                        <input type="checkbox" class="form-control" id="non_chiamare" v-model="non_chiamare">
                    </div> -->
                </div>
                <div class="form-row">
                    <!-- <div class="form-group col-md-6">
                        <label for="fonte_lead">Fonte del lead</label>
                        <select class="form-control" v-model="fonte_lead">
                            <option>..</option>
                            <option>..</option>
                        </select>
                    </div> -->
                    <div class="form-group col-md-6">
                        <label for="assegnato_a">Assegnato a</label>
                        <input type="text" class="form-control" v-model="assegnato_a" id="assegnato_a">
                    </div>
                </div>
                <div class="form-row">
                    
                </div>
                <button type="button" class="btn float-right" style="background:#00467f" v-on:click="salvaCorsista()">Salva</button>
            </form>
        </card>
    </div>
</template>
<script>
import axios from 'axios';
import Card from '@/components/Cards/Card.vue';
import {Modal} from '@/components';
// import NoteServices from '@/services/NoteServices';
// import PraticheServices from '@/services/PraticheServices';
import Services from '@/services/Services';
import CorsoServices from '@/services/CorsoServices';

export default {
    components: {
      Card,
      Modal
    },
  
    data() {
        return {
            carica_corsista: [],
            file: null,

            //pop up per cercare 
            showRisultati: false,
            nessunRisulato: false,
            cerca_azienda: '',
            cerca_codice_fiscale: '',
            cerca_p_iva: '',
            cerca_info: [],
            denominazione_search: null,
            codice_fiscale_search: null,
            partita_iva_search: null,
            
            // corsista 
            nome_corsista: null,
            nome_azienda: null,
            cognome_corsista: null, 
            ufficio_corsista: null,
            mansione_corsista: null,
            cellulare_corsista: null,
            fax_corsista: null,
            non_chiamare: false,
            email_corsista: null,
            fonte_lead: null,
            assegnato_a: null,

            idCorso: null,
            showDelete: false,
            confermaCancella: false,
            access_token: null,
            token_response: [],
            urlRichieste: 'https://sviluppoallergeni.confcom.it/'   //'https://apiintranet.confcom.it/'
        }
    },
    methods: {
        cercaInfo: async function() {
            let errore = 0;
            const token = localStorage.getItem('access_token');
            await Services.searchInformation(this.cerca_azienda, this.cerca_codice_fiscale, this.cerca_p_iva)
            .then(response => { this.cerca_info = response.data})
            .catch( function (error) {
                // handle error
                if(error.response.status == 401){
                errore = error.response.status;
                }
            })
            if (errore == 401) {
            let value = await this.refreshToken();
            if (value) { await this.cercaInfo(); }
            }
            this.showRisultati = true;
            if (this.cerca_info.length == 0) {
            this.nessunRisulato = true;
            }
        },

        caricaCorsista: async function() {
            let response_dati = [];
            await CorsoServices.getCorsista()
            .then(response => { response_dati = response.data })
            .catch( function (error) {
                if (error.response.status == 401) {
                    errore = error.response.status;
                }
            })
            if (errore == 401) {
                let value = await this.refreshToken();
                if (value) { await this.salvaCorsista(); }
            }
            this.cf_corsista = response_dati.CF;
            this.nome_corsista = response_dati.NOME;
            this.cognome_corsista = response_dati.COGNOME;
            // this.nome_azienda = response_dati.
            this.cellulare_corsista = response_dati.CELLULARE;
            this.email_corsista = response_dati.EMAIL;
            // this.mansione_corsista

        },

        logout: async function () {
            await Services.logout()
            .then(response => { this.results = response.data})
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.setItem('isLogged', false);
            localStorage.removeItem('user_nome');
            localStorage.removeItem('user_cognome');
            localStorage.removeItem('user_tipologia');
            localStorage.removeItem('user_email');
            localStorage.removeItem('user_livello');
            localStorage.removeItem('user_id');
            this.$router.push({
            path: '/login'
            })
            // window.location.reload()
        },

        refreshToken: async function() {
            let errore = 0;
            await Services.refreshToken()
            .then(response => { this.token_response = response.data})
            .catch(function (error) {
                // handle error
                if(error.response.status == 403 || error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if (errore == 403 || errore == 401) {
                await this.logout();
                return false;
            }
            localStorage.setItem("access_token", this.token_response.accessToken);
            this.access_token = localStorage.getItem('access_token');
            return true;
        },

        salvaCorsista: async function() {
            let response_dati = [];
            let errore = 0;
            let dati = [{ CF: this.cf_corsista, NOME: this.nome_corsista, COGNOME: this.cognome_corsista, AZIENDA: this.nome_azienda, CELLULARE: this.cellulare_corsista, EMAIL: this.email_corsista, MANSIONE: this.mansione_corsista }];
            await CorsoServices.creaCorsista()
            .then(response => { response_dati = response.data })
            .catch( function (error) {
                if (error.response.status == 401) {
                    errore = error.response.status;
                }
            })
            if (errore == 401) {
                let value = await this.refreshToken();
                if (value) { await this.salvaCorsista(); }
            }
        },

        main: async function() {
            this.user_livello = localStorage.getItem('user_livello');
            this.idCorso = this.$route.query.idCorso;
            this.idCorsista = this.$route.query.idCorsista;
            console.log(`idCorso=${this.idCorso}, idCorsista=${this.idCorsista}`);
            this.access_token = localStorage.getItem('access_token');
            axios.defaults.withCredentials = true;
            try {
                if (this.idCorso != null && this.idCorsista != null) {
                    await this.caricaCorsista();
                }
            } catch (error) {
                if (error.response.status == 401) {
                    await this.refreshToken();
                }
            }  
        }
    },

    mounted() {},
    
    beforeMount() {
        this.main();
    }
  };
</script>
<style scoped>
/* body {
    margin: 10px; 
     padding: 10px;
} */
form {
    /* max-width: 580px; */
    margin: auto;
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.input-icon {
  position: relative;
}

.input-icon > i {
  position: absolute;
  display: block;
  transform: translate(0, -50%);
  top: 50%;
  pointer-events: none;
  width: 25px;
  text-align: center;
	font-style: normal;
}

.input-icon > input {
  padding-left: 25px;
padding-right: 0;
}

.input-icon-right > i {
  right: 0;
}

.input-icon-right > input {
  padding-left: 0;
  padding-right: 25px;
  text-align: right;
}

</style>
  